import { PermissionName } from '@utmost.co/enterprise-models';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { EngagementNavItem, ENGAGEMENTS_TAB, PATH_SCHEMA, SupportedFlags } from './EngagementsHome.constants';
import GenderPage from './Gender/GenderPage';
import { EngagementsGeneral } from './General/EngagementsGeneral';
import { JobCatalogues } from './JobCatalogues/JobCataloguesPage';
import { RateCardsPage } from './RateCards/RateCards';
import { TerminationReasonsPage } from './TerminationReasons/TerminationReasonsPage';

export const navItems: EngagementNavItem[] = [
  getDefaults(ENGAGEMENTS_TAB.GENERAL, EngagementsGeneral, 'SETTINGS_ENGAGEMENTS'),
  getDefaults(ENGAGEMENTS_TAB.JOB_CATALOGUES, JobCatalogues, 'JOB_PROFILE'),
  getDefaults(ENGAGEMENTS_TAB.RATE_CARDS, RateCardsPage, 'RATE_CARD'),
  getDefaults(ENGAGEMENTS_TAB.TERMINATION_REASONS, TerminationReasonsPage, 'REFERENCE_DATA'),
  getDefaults(ENGAGEMENTS_TAB.GENDER, GenderPage, 'REFERENCE_DATA')
];

function getDefaults(
  tab: ENGAGEMENTS_TAB,
  component?:
    | React.ComponentType<React.PropsWithChildren<RouteComponentProps>>
    | React.ComponentType<React.PropsWithChildren>,
  staticPermission?: PermissionName,
  flag?: SupportedFlags
): EngagementNavItem {
  return {
    label: `engagements.${tab}`,
    path: tab,
    pathSchema: `/:tenantCode${PATH_SCHEMA}/${tab}`,
    'data-test': `${tab}__settings__tab`,
    component,
    permissions: staticPermission ? [{ name: staticPermission, action: 'READ' }] : [],
    flag
  };
}
